module.exports = __webpack_public_path__ + "img/ziraat_bankasi_logo.a344d037.svg";